import Api from './PhiApi'

export default class PhiReporting {

    constructor(options) {
        this.phiRef = options

        this.makeACall = function* (that, config) {
            let token = that.phiRef.getSession()
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.makeACall(config)
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results
                } else {
                    return { error: response.problem }
                }
            }
        }

        this.sendOtp = function* (that, params) {
            const response = yield Api.sendOtp(params);

            if (response.ok && response.data && response.data.status === 200) {
                return true;
            } else return false;
        };

    }
}